
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13185',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13185",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.703",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9934",
  "foundations-components": "static-1.8457",
  "foundations-components-legacy": "static-1.1482",
  "foundations-theming": "static-1.4750",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.86",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8310",
  "hub-http-shared-msw-handlers": "static-1.10579",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11764",
  "I18n": "static-7.1669",
  "jasmine-runner": "static-1.6730",
  "marketplace-discovery-studio-lib": "static-1.599",
  "marketplace-storefront-base": "static-1.13248",
  "quartz": "static-1.7428",
  "react-dlb": "static-1.88",
  "react-rhumb": "static-1.16995",
  "reactive-variable-buffer-atom": "static-1.3133",
  "reporting-testing-lib": "static-1.10681",
  "reselect": "static-3.9",
  "settings-ui-lib": "static-1.12802",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7598",
  "ui-addon-i18n": "static-1.11423",
  "ui-addon-react-router-dom": "static-1.9815",
  "unified-auth": "static-1.871",
  "unified-auth-core-lib": "static-1.1153",
  "usage-tracker": "static-1.7633",
  "usage-tracker-core": "static-1.7483",
  "customer-data-property-utils": "static-1.8379",
  "hub-http": "static-1.6490",
  "integrations-lib": "static-1.16986",
  "marketplace-ui-common": "static-1.20672",
  "marketplace-ui-install": "static-1.658",
  "property-management-iframe": "static-1.14088",
  "quartz-config": "static-1.1206",
  "quartz-core": "static-1.6647",
  "quartz-routing": "static-1.858",
  "quick-fetch": "static-1.4115",
  "react": "static-7.192",
  "rpc-client-utils": "static-1.4944",
  "ts-schema": "static-1.4277",
  "ui-universal-auth": "static-1.9357",
  "UIComponents": "static-3.8710",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3603",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3705",
  "quartz-webpack": "static-1.3652",
  "bend-plugin-quartz-routing": "static-1.506",
  "ai-components-ui-library": "static-1.9668",
  "codemirror": "static-5.99",
  "foundations-assets": "static-1.5161",
  "pulse": "static-1.906",
  "react-codemirror": "static-1.10917",
  "ui-extensions-preview-lib": "static-1.561",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4726",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2466",
  "framer-motion": "static-1.76",
  "hs-story-utils": "static-1.9704",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.68",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5540",
  "react-virtualized": "static-2.104",
  "StyleGuideUI": "static-3.500",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2576",
  "ui-fonts": "static-1.1026",
  "ui-images": "static-2.1238",
  "bend-plugin-foundations-theming": "static-1.3233",
  "foundations-theming-base": "static-1.3735",
  "stylex": "static-1.38",
  "HeadJS": "static-2.794",
  "hs-test-utils-bend-plugin": "static-1.3421",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.88",
  "jasmine": "static-4.4591",
  "ui-addon-video-player": "static-1.8981",
  "ai-rendering-library": "static-1.11059",
  "chirp-fetch": "static-1.2173",
  "connections-embed-lib": "static-1.1480",
  "copilot-toolkit": "static-1.11813",
  "feedback-loader": "static-1.29777",
  "laboratory-lib": "static-3.7428",
  "marketplace-embed": "static-1.22862",
  "marketplace-ui-details": "static-1.10567",
  "marketplace-ui-reviews": "static-1.20627",
  "marketplace-ui-tracking": "static-1.14842",
  "sanitize-text": "static-1.8431",
  "usage-tracker-multi": "static-1.6047",
  "usage-tracker-session-replay": "static-1.5319",
  "wootric-nps": "static-1.7184",
  "quartz-head": "static-1.1093",
  "web-vitals": "static-1.12",
  "apollo-link-hub-http": "static-2.4933",
  "immer": "static-1.97",
  "immerable": "static-1.4427",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2669",
  "reporting-data": "static-1.68748",
  "cssUtils": "static-1.898",
  "flux-actions": "static-1.365",
  "react-colorpicker": "static-2.10486",
  "react-dnd-compat": "static-1.4895",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10647",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7623",
  "icons": "static-2.677",
  "marketplace-ui-apps-core": "static-1.19204",
  "storybook-react": "static-1.37",
  "trellis-story-utils": "static-1.4786",
  "foundations-components-test-utils": "static-1.5940",
  "quartz-i18n": "static-1.1103",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.419",
  "ads-unified-auth-lib": "static-1.1232",
  "google-sheets-integration-lib": "static-1.988",
  "microsoft-drive-auth-lib": "static-1.89",
  "surveymonkey-integration-lib": "static-1.429",
  "slack-ui-library": "static-1.10676",
  "fsm": "static-1.4026",
  "customer-data-objects": "static-1.7968",
  "property-translator": "static-1.5676",
  "hs-locale-management": "static-1.277",
  "frontend-preferences-client": "static-1.8200",
  "hs-promise-utils": "static-1.5875",
  "hubspot-apollo-client": "static-1.5157",
  "integrations-error-boundary-lib": "static-1.14401",
  "integrations-tracking-lib": "static-1.5887",
  "native-integrations-shared-strings": "static-1.8056",
  "sanitize": "static-1.4751",
  "superstore": "static-1.5034",
  "ui-shepherd-react": "static-3.10546",
  "ai-settings-ui-library": "static-1.8293",
  "hub-http-janus": "static-1.875",
  "hubspotter-http": "static-1.4848",
  "immutable-less": "static-1.4928",
  "marketplace-ui-client-types": "static-1.18079",
  "nav-meta": "static-1.30419",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18353",
  "ui-product-approvals-common": "static-1.977",
  "ai-studio-lib": "static-1.12418",
  "hubspot-prosemirror": "static-1.18930",
  "integrations-reconnect-lib": "static-1.453",
  "ui-addon-iframeable": "static-1.9355",
  "ui-addon-integrations-directory-panel": "static-2.8302",
  "ui-product-approvals": "static-1.29082",
  "ui-tool-access": "static-1.10431",
  "inbound-db-properties-service-client": "static-1.4041",
  "property-management-common": "static-1.6376",
  "opentelemetry-fe-types": "static-1.48",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.574",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.423",
  "quartz-auth": "static-1.1103",
  "quartz-test": "static-1.1103",
  "quartz-tracking": "static-1.807",
  "trellis-components": "static-1.2595",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.354",
  "HubStyle": "static-2.12071",
  "bender-build-tools": "static-1.3425",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22870",
  "ContentUtils": "static-1.69081",
  "customer-data-objects-ui-components": "static-1.13309",
  "sassPrefix": "static-1.170",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.409",
  "batch-promise": "static-1.1822",
  "event-emitter": "static-1.1230",
  "fast-json-patch": "static-1.67",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5738",
  "magpie-types": "static-1.5198",
  "stylex-utils": "static-1.137",
  "trellis-theming": "static-1.1249",
  "avatar-components": "static-1.2766",
  "breeze-engine-core": "static-1.940",
  "breeze-onboarding-components": "static-1.673",
  "customer-data-filters-ui": "static-1.40851",
  "customer-data-reference-ui-components": "static-1.13457",
  "embedded-academy-lib": "static-1.15469",
  "ExportDialog": "static-6.10656",
  "global-styles-ai-lib": "static-1.20",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41987",
  "reporting-snowflake": "static-1.57365",
  "reporting-ui-components": "static-2.66018",
  "reporting-visualizations": "static-1.60823",
  "trial-components-library": "static-1.14073",
  "ui-addon-teams": "static-1.21884",
  "upgrade-components-lib": "static-1.488",
  "navigation-components": "static-1.18782",
  "breeze-engine-lib": "static-1.1662",
  "simple-logging-lib": "static-1.3328",
  "fail-safe": "static-1.231",
  "app-governance-lib": "static-1.2349",
  "developer-experience-shared-components": "static-1.10782",
  "purchase-motions-components": "static-1.6331",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10170",
  "usage-tracker-anonymous": "static-1.6050",
  "usage-tracker-public": "static-1.7444",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3979",
  "reference-resolvers": "static-1.8459",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4196",
  "hubspot-apollo-cache": "static-1.616",
  "universal-page-editor-lib": "static-1.3285",
  "final-form": "static-1.75",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3494",
  "atom": "static-1.5363",
  "merchandise-lib": "static-1.276",
  "salesImages": "static-1.541",
  "ui-addon-draggable": "static-3.5037",
  "content-assistance-lib": "static-1.8170",
  "content-media-capture": "static-1.5390",
  "customer-data-ui-utilities": "static-1.10106",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24437",
  "growth-payments-core": "static-1.26136",
  "knowledge-content-types": "static-1.8638",
  "PatternValidationJS": "static-1.3172",
  "payment-link-components": "static-1.24128",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20275",
  "ui-addon-emoji-picker": "static-1.10164",
  "ui-business-units-lib": "static-1.9365",
  "video-components-external": "static-1.12113",
  "video-data-lib": "static-1.35771",
  "navigation-messaging": "static-1.8109",
  "collaboration-sidebar": "static-1.58676",
  "crm-component-utils": "static-1.39792",
  "crm-properties-common-lib": "static-1.6168",
  "customer-data-properties": "static-1.52515",
  "external-options-client-types": "static-1.4324",
  "framework-data-schema-resolvers": "static-1.7169",
  "property-value-citations": "static-1.3129",
  "reference-resolvers-lite": "static-1.8380",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10577",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5093",
  "content-icons-ui": "static-1.2342",
  "idb-keyval": "static-1.48",
  "reactive-lib": "static-1.997",
  "breeze-artifacts-sdk": "static-1.265",
  "onboarding-journeys-lib": "static-1.880",
  "conversations-skeleton-state": "static-1.7524",
  "crm-message-bus": "static-1.43711",
  "customer-data-filters-ui-msw-helpers": "static-1.23286",
  "events-data-lib": "static-1.521",
  "FormUrlGenerator": "static-2.5006",
  "framework-builder-read-service-client": "static-1.4206",
  "hs-resources": "static-1.471",
  "multi-account-reference-resolvers": "static-1.1279",
  "onboarding-scopes": "static-1.6731",
  "onboarding-tours": "static-1.17084",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14424",
  "academy-common-lib": "static-1.14929",
  "dashboard-lib": "static-1.82745",
  "getting-started-shared-tasks": "static-1.19192",
  "hubspot-prosemirror-plugins": "static-1.18922",
  "share-with-third-party-component-lib": "static-1.8983",
  "ui-asset-management-lib": "static-1.11375",
  "user-context": "static-1.5397",
  "reporting-plugins": "static-1.10716",
  "reporting-reports": "static-1.68425",
  "hubs-service-types": "static-1.1535",
  "purchase-motions-api": "static-1.6334",
  "signup-constants": "static-1.19582",
  "nest": "static-1.513",
  "breeze-engine-chat-components": "static-1.640",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.182",
  "framework-listing-lib": "static-2.29449",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31379",
  "apps-service-types": "static-1.4018",
  "oauth-service-types": "static-1.4514",
  "signup-ui-url-generator": "static-2.8340",
  "onboarding-tours-client": "static-1.5299",
  "one-click-checkout": "static-1.352",
  "platform-infra-nav-components": "static-1.7877",
  "subscription-experience-data-types": "static-1.15231",
  "crm-record-cards-service-types": "static-1.3770",
  "location-customization-utils-lib": "static-1.10055",
  "redux-thunk": "static-2.77",
  "react-flip-move": "static-1.75",
  "ui-coaching-tips": "static-1.29265",
  "content-media-composition-data-lib": "static-1.13194",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4703",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.673",
  "ui-addon-opt": "static-4.8641",
  "commerce-tours-lib": "static-1.6582",
  "growth-onboarding-reliability": "static-1.5358",
  "sales-checkout-service-client": "static-1.3807",
  "data-token-picker": "static-1.16856",
  "FileManagerLib": "static-1.40077",
  "content-media-compositions": "static-2.17201",
  "media-bridge-lib": "static-1.19376",
  "chatspot-widget-iframe": "static-1.22861",
  "collaboration-sidebar-common": "static-1.3473",
  "marketing-platform-lib": "static-1.7148",
  "card-properties-lib": "static-1.44966",
  "commerce-subscription-lib": "static-1.37734",
  "crm-actions": "static-1.6631",
  "crm-cards-sdk": "static-1.44506",
  "customer-data-properties-shared-msw-handlers": "static-1.9906",
  "customer-data-tracking": "static-1.7160",
  "calling-global-api": "static-1.65529",
  "calling-internal-common": "static-1.31596",
  "calling-lifecycle-internal": "static-1.66911",
  "calling-lifecycle-messages": "static-1.59205",
  "commerce-products-lib": "static-1.10484",
  "conditional-properties-service-client": "static-1.3997",
  "crm-index-visualization-core": "static-1.4515",
  "crm-links": "static-1.6608",
  "crm-pipelines-api-client-types": "static-1.4331",
  "formula-editor": "static-1.14720",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4411",
  "meetings-icalendar-utils-lib": "static-1.913",
  "multi-currency-client-types": "static-1.3892",
  "object-builder-ui-client": "static-1.49619",
  "pipeline-validation-client-types": "static-1.4165",
  "smart-data-capture-core": "static-1.97",
  "smart-property-lib": "static-1.8242",
  "tiered-pricing": "static-1.1920",
  "topics-actions-lib": "static-1.442",
  "ui-addon-form-validation": "static-1.11261",
  "zustand": "static-1.82",
  "fdsr-migration-layer": "static-1.288",
  "framework-data-schema-quick-fetch": "static-1.7074",
  "restore-request-side-panel-lib": "static-1.1627",
  "growth-data-modal": "static-1.5862",
  "growth-onboarding-confetti": "static-1.3339",
  "growth-onboarding-next-action-utils": "static-1.2646",
  "onboarding-tours-utils": "static-1.1151",
  "ui-shepherd-tracker": "static-1.7927",
  "academy-service-client": "static-1.3965",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39936",
  "SafeStorage": "static-1.4681",
  "video-embed": "static-1.36605",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24966",
  "viral-links-lib": "static-1.7353",
  "nested-table": "static-1.511",
  "timezone-utils": "static-2.5523",
  "getting-started-shared-tasks-store": "static-1.18310",
  "campaign-roi-lib": "static-1.10129",
  "campaigns-utils-lib": "static-1.3484",
  "ui-addon-calendars": "static-2.5606",
  "customer-data-views-management": "static-1.25982",
  "framework-data-table": "static-2.12507",
  "nudge-client-utils": "static-1.3121",
  "nudge-custom-ui-functions": "static-1.1459",
  "switchboard-lib": "static-1.492",
  "access-check-ui-lib": "static-1.1540",
  "app-users-service-client": "static-1.5897",
  "app-users-service-types": "static-1.5305",
  "mini-checkout-client": "static-1.27447",
  "onboarding-utils": "static-1.5643",
  "permissions-shared-i18n-strings-fe": "static-1.2119",
  "ui-coaching-tips-shared-config": "static-1.29250",
  "checkout-sdk": "static-3.24290",
  "payment-method-components": "static-1.7126",
  "touchless-buying-components": "static-1.6158",
  "upgrade-catalog-service-types": "static-1.3748",
  "edison-service-client-types": "static-1.670",
  "growth-onboarding-feedback-components": "static-1.6862",
  "audio-components": "static-1.6311",
  "FileManagerImages": "static-1.37588",
  "video-components": "static-1.14115",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92780",
  "customer-data-sidebar": "static-2.46697",
  "enrichment-lib": "static-1.278",
  "ui-addon-draggable-compat": "static-2.4544",
  "universal-record-utils-lib": "static-1.1826",
  "commerce-billing-lib": "static-1.20106",
  "commerce-shared-components-lib": "static-1.19179",
  "commerce-tools-ui-lib": "static-1.11004",
  "crm-fe-perf": "static-1.23180",
  "calling-error-reporting": "static-1.31603",
  "shared-worker-versioning": "static-1.11318",
  "calling-usage-tracker": "static-1.6815",
  "voice-sms-access-library": "static-1.1981",
  "commerce-permissions": "static-1.1056",
  "products-iframe-lib": "static-1.8548",
  "products-ui-components-shared-msw-handlers": "static-1.10961",
  "crm-index-associations-lib": "static-1.6720",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10662",
  "sales-views-client-types": "static-1.4533",
  "bark-lib": "static-1.16789",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.617",
  "policy-lib": "static-1.7078",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10725",
  "onboarding-data-sync-lib": "static-1.2473",
  "growth-onboarding-next-action-components": "static-1.2674",
  "user-context-client": "static-1.4787",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4810",
  "outpost": "static-1.4435",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22126",
  "sales-email-signature-service-client": "static-1.4122",
  "ts-utils-lib": "static-1.426",
  "crm-export-dialog": "static-1.6561",
  "crm-view-components": "static-1.1061",
  "react-beautiful-dnd": "static-1.67",
  "customer-data-associations": "static-1.7605",
  "tasks-actions-lib": "static-1.81",
  "nudge-custom-function-registry": "static-1.2878",
  "nudge-renderer-utils": "static-1.3197",
  "whisper-core-api": "static-1.7283",
  "InboxConnectUtils": "static-4.15516",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46800",
  "hub-http-rxjs": "static-1.838",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4266",
  "company-details-components": "static-1.6481",
  "react-performance-metrics-lib": "static-1.833",
  "pricing-pages-ui-components": "static-1.15681",
  "quote-checkout-service-types": "static-1.3731",
  "social-insights-client-types": "static-1.22692",
  "crm_universal": "static-1.22468",
  "customer-data-email": "static-1.18495",
  "card-payment-highlight-lib": "static-1.37935",
  "commerce-contract-lib": "static-1.13260",
  "invoices-highlight-card-lib": "static-1.55677",
  "orders-highlight-card-lib": "static-1.22151",
  "products-highlight-card-lib": "static-1.18767",
  "quotes-highlight-card-lib": "static-1.72789",
  "crm-source-interpretation-lib": "static-1.5607",
  "data-agent-utils": "static-1.340",
  "crm-object-search-query-utilities": "static-1.10158",
  "utility-belt": "static-1.2811",
  "payments-enrollment-embed-lib": "static-1.23753",
  "stripe-embedded-components": "static-1.7968",
  "customer-data-rte": "static-1.33609",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6238",
  "payments-post-enroll-local-storage-lib": "static-1.5383",
  "qrcode-generator": "static-1.73",
  "quotes-client-types": "static-1.38879",
  "calling-orchestration-schema": "static-1.36758",
  "react-reducer-toolkit": "static-1.16323",
  "meetings-connect-utils-lib": "static-1.7886",
  "hub-http-contrib": "static-1.3317",
  "ui-addon-sales-email": "static-1.5490",
  "access-control-lib": "static-1.10713",
  "EmailComponents": "static-1.55506",
  "EmailData": "static-1.54184",
  "redux-less": "static-2.9755",
  "company-details-service-types": "static-1.4217",
  "segments-query-core": "static-1.1701",
  "pricing-pages-api": "static-1.15546",
  "sequences-lib": "static-1.8504",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.41002",
  "accounting-integrations-ui-components": "static-1.7506",
  "invoices-ui-lib": "static-1.55693",
  "commerce-products-api": "static-1.2667",
  "invoices-iframe-lib": "static-1.57751",
  "quotes-modal-lib": "static-1.103467",
  "quotes-ui-lib": "static-1.81510",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28868",
  "ContentComponents": "static-2.72037",
  "ContentData": "static-1.69156",
  "marketing-contacts-lib": "static-1.10972",
  "marketing-email-service-types": "static-1.2080",
  "messaging-editing-lib": "static-1.47088",
  "messaging-usage-based-billing-components-lib": "static-1.1950",
  "automation-ui-source-apps": "static-1.19645",
  "automation-ui-types": "static-1.20563",
  "messaging-types-lib": "static-1.46825",
  "onboarding-settings-client": "static-1.4787",
  "sequences-client-types-lib": "static-1.8361",
  "commerce-tax-lib": "static-1.816",
  "price-books-api": "static-1.1693",
  "price-books-components": "static-1.1751",
  "property-description-translator": "static-1.4119",
  "ramp-editor": "static-1.854",
  "commerce-analytics-service-client": "static-1.3795",
  "totals-ui-components": "static-1.24254",
  "SalesContentIndexUI": "static-3.9601",
  "advanced-menus-core": "static-1.15547",
  "advanced-menus-lib": "static-1.12424",
  "automation-ui-ubb": "static-1.6479",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7615",
  "data-token-views": "static-1.16837",
  "forms-utils-lib": "static-1.13065",
  "payments-embed-points-lib": "static-1.13553",
  "react-tinymce": "static-1.55934",
  "simple-menus-core": "static-1.15546",
  "simple-menus-lib": "static-1.17063",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55060",
  "tinymce-data": "static-1.41145",
  "tinymce-plugins": "static-1.58174",
  "tinymce-themes": "static-1.57030",
  "ui-brand-identity-lib": "static-1.16393",
  "ui-memberships-settings-lib": "static-1.34799",
  "videoconference-integration-components": "static-1.7229",
  "marketing-contacts-client": "static-1.7788",
  "mc-hard-limits-client-types": "static-1.182",
  "automation-applications-service-types": "static-1.3651",
  "automation-platform-service-types": "static-1.2662",
  "ContentEditorUI": "static-2.77860",
  "short-messages-app-service-client": "static-1.4190",
  "web-interactives-components": "static-1.14218",
  "web-interactives-data": "static-1.14219",
  "messaging-shared-utils-lib": "static-1.1399",
  "messaging-user-info-utils-lib": "static-1.1569",
  "email-portal-health-service-types": "static-1.1257",
  "line-items-api": "static-1.1068",
  "commerce-totals-service-types": "static-1.4016",
  "FireAlarmUi": "static-1.4704",
  "sales-templates-service-types-lib": "static-1.4368",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22499",
  "automation-ui-usage-tracking": "static-1.21962",
  "data-studio-ubb": "static-1.3468",
  "interframe": "static-3.5032",
  "layout-dnd-components": "static-1.12934",
  "layout-dnd-utils": "static-1.11909",
  "NamespacedHubStyle": "static-2.9247",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27610",
  "content-management-data-lib": "static-1.5922",
  "copilot-plugins": "static-1.11785",
  "cta-picker": "static-1.37045",
  "customer-agent-discovery-components-lib": "static-1.3866",
  "editor-components": "static-1.13620",
  "editor-iframe-lib": "static-1.8769",
  "error-messaging-js": "static-1.5474",
  "FormsCommonComponents": "static-1.86518",
  "layout-data-lib": "static-1.10234",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.70",
  "redux-request-state": "static-1.10926",
  "SharedLegalStrings": "static-1.2024",
  "smart-content-core": "static-1.43135",
  "smart-content-lib": "static-1.43788",
  "social-composer-lib": "static-1.60210",
  "structured-content-lib": "static-1.25876",
  "theme-previewer-lib": "static-1.53904",
  "tinymce-copilot": "static-1.17128",
  "xray-recommendation-lib": "static-1.8237",
  "automation-ui-routing": "static-1.21920",
  "sql-reporting-client-types": "static-1.5877",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42754",
  "reporting-enablement": "static-1.23786",
  "forms-ai-lib": "static-1.4734",
  "codemirror-dlb": "static-1.59419",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6716",
  "report-customization-components": "static-1.13870",
  "data-quality-ui-library": "static-1.13754",
  "reporting-filters": "static-1.965",
  "reporting-insights-lib": "static-1.2525",
  "segments-client-types": "static-1.11463"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13185",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.703",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9934",
  "foundations-components": "/foundations-components/static-1.8457",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1482",
  "foundations-theming": "/foundations-theming/static-1.4750",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.86",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8310",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10579",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11764",
  "I18n": "/I18n/static-7.1669",
  "jasmine-runner": "/jasmine-runner/static-1.6730",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.599",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13248",
  "quartz": "/quartz/static-1.7428",
  "react-dlb": "/react-dlb/static-1.88",
  "react-rhumb": "/react-rhumb/static-1.16995",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3133",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10681",
  "reselect": "/reselect/static-3.9",
  "settings-ui-lib": "/settings-ui-lib/static-1.12802",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7598",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11423",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9815",
  "unified-auth": "/unified-auth/static-1.871",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1153",
  "usage-tracker": "/usage-tracker/static-1.7633",
  "usage-tracker-core": "/usage-tracker-core/static-1.7483",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8379",
  "hub-http": "/hub-http/static-1.6490",
  "integrations-lib": "/integrations-lib/static-1.16986",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20672",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.658",
  "property-management-iframe": "/property-management-iframe/static-1.14088",
  "quartz-config": "/quartz-config/static-1.1206",
  "quartz-core": "/quartz-core/static-1.6647",
  "quartz-routing": "/quartz-routing/static-1.858",
  "quick-fetch": "/quick-fetch/static-1.4115",
  "react": "/react/static-7.192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4944",
  "ts-schema": "/ts-schema/static-1.4277",
  "ui-universal-auth": "/ui-universal-auth/static-1.9357",
  "UIComponents": "/UIComponents/static-3.8710",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3603",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3705",
  "quartz-webpack": "/quartz-webpack/static-1.3652",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.506",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9668",
  "codemirror": "/codemirror/static-5.99",
  "foundations-assets": "/foundations-assets/static-1.5161",
  "pulse": "/pulse/static-1.906",
  "react-codemirror": "/react-codemirror/static-1.10917",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.561",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4726",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2466",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-story-utils": "/hs-story-utils/static-1.9704",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5540",
  "react-virtualized": "/react-virtualized/static-2.104",
  "StyleGuideUI": "/StyleGuideUI/static-3.500",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2576",
  "ui-fonts": "/ui-fonts/static-1.1026",
  "ui-images": "/ui-images/static-2.1238",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3233",
  "foundations-theming-base": "/foundations-theming-base/static-1.3735",
  "stylex": "/stylex/static-1.38",
  "HeadJS": "/HeadJS/static-2.794",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3421",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.88",
  "jasmine": "/jasmine/static-4.4591",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8981",
  "ai-rendering-library": "/ai-rendering-library/static-1.11059",
  "chirp-fetch": "/chirp-fetch/static-1.2173",
  "connections-embed-lib": "/connections-embed-lib/static-1.1480",
  "copilot-toolkit": "/copilot-toolkit/static-1.11813",
  "feedback-loader": "/feedback-loader/static-1.29777",
  "laboratory-lib": "/laboratory-lib/static-3.7428",
  "marketplace-embed": "/marketplace-embed/static-1.22862",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10567",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20627",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14842",
  "sanitize-text": "/sanitize-text/static-1.8431",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6047",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5319",
  "wootric-nps": "/wootric-nps/static-1.7184",
  "quartz-head": "/quartz-head/static-1.1093",
  "web-vitals": "/web-vitals/static-1.12",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4933",
  "immer": "/immer/static-1.97",
  "immerable": "/immerable/static-1.4427",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2669",
  "reporting-data": "/reporting-data/static-1.68748",
  "cssUtils": "/cssUtils/static-1.898",
  "flux-actions": "/flux-actions/static-1.365",
  "react-colorpicker": "/react-colorpicker/static-2.10486",
  "react-dnd-compat": "/react-dnd-compat/static-1.4895",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10647",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7623",
  "icons": "/icons/static-2.677",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19204",
  "storybook-react": "/storybook-react/static-1.37",
  "trellis-story-utils": "/trellis-story-utils/static-1.4786",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5940",
  "quartz-i18n": "/quartz-i18n/static-1.1103",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.419",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1232",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.988",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.89",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.429",
  "slack-ui-library": "/slack-ui-library/static-1.10676",
  "fsm": "/fsm/static-1.4026",
  "customer-data-objects": "/customer-data-objects/static-1.7968",
  "property-translator": "/property-translator/static-1.5676",
  "hs-locale-management": "/hs-locale-management/static-1.277",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8200",
  "hs-promise-utils": "/hs-promise-utils/static-1.5875",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5157",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14401",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5887",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8056",
  "sanitize": "/sanitize/static-1.4751",
  "superstore": "/superstore/static-1.5034",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10546",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8293",
  "hub-http-janus": "/hub-http-janus/static-1.875",
  "hubspotter-http": "/hubspotter-http/static-1.4848",
  "immutable-less": "/immutable-less/static-1.4928",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18079",
  "nav-meta": "/nav-meta/static-1.30419",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18353",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.977",
  "ai-studio-lib": "/ai-studio-lib/static-1.12418",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18930",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.453",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9355",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8302",
  "ui-product-approvals": "/ui-product-approvals/static-1.29082",
  "ui-tool-access": "/ui-tool-access/static-1.10431",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4041",
  "property-management-common": "/property-management-common/static-1.6376",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.48",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.574",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.423",
  "quartz-auth": "/quartz-auth/static-1.1103",
  "quartz-test": "/quartz-test/static-1.1103",
  "quartz-tracking": "/quartz-tracking/static-1.807",
  "trellis-components": "/trellis-components/static-1.2595",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.354",
  "HubStyle": "/HubStyle/static-2.12071",
  "bender-build-tools": "/bender-build-tools/static-1.3425",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22870",
  "ContentUtils": "/ContentUtils/static-1.69081",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13309",
  "sassPrefix": "/sassPrefix/static-1.170",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.409",
  "batch-promise": "/batch-promise/static-1.1822",
  "event-emitter": "/event-emitter/static-1.1230",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5738",
  "magpie-types": "/magpie-types/static-1.5198",
  "stylex-utils": "/stylex-utils/static-1.137",
  "trellis-theming": "/trellis-theming/static-1.1249",
  "avatar-components": "/avatar-components/static-1.2766",
  "breeze-engine-core": "/breeze-engine-core/static-1.940",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.673",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40851",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13457",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15469",
  "ExportDialog": "/ExportDialog/static-6.10656",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.20",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41987",
  "reporting-snowflake": "/reporting-snowflake/static-1.57365",
  "reporting-ui-components": "/reporting-ui-components/static-2.66018",
  "reporting-visualizations": "/reporting-visualizations/static-1.60823",
  "trial-components-library": "/trial-components-library/static-1.14073",
  "ui-addon-teams": "/ui-addon-teams/static-1.21884",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.488",
  "navigation-components": "/navigation-components/static-1.18782",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1662",
  "simple-logging-lib": "/simple-logging-lib/static-1.3328",
  "fail-safe": "/fail-safe/static-1.231",
  "app-governance-lib": "/app-governance-lib/static-1.2349",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10782",
  "purchase-motions-components": "/purchase-motions-components/static-1.6331",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10170",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6050",
  "usage-tracker-public": "/usage-tracker-public/static-1.7444",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3979",
  "reference-resolvers": "/reference-resolvers/static-1.8459",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4196",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.616",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3285",
  "final-form": "/final-form/static-1.75",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3494",
  "atom": "/atom/static-1.5363",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "salesImages": "/salesImages/static-1.541",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5037",
  "content-assistance-lib": "/content-assistance-lib/static-1.8170",
  "content-media-capture": "/content-media-capture/static-1.5390",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10106",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24437",
  "growth-payments-core": "/growth-payments-core/static-1.26136",
  "knowledge-content-types": "/knowledge-content-types/static-1.8638",
  "PatternValidationJS": "/PatternValidationJS/static-1.3172",
  "payment-link-components": "/payment-link-components/static-1.24128",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20275",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10164",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9365",
  "video-components-external": "/video-components-external/static-1.12113",
  "video-data-lib": "/video-data-lib/static-1.35771",
  "navigation-messaging": "/navigation-messaging/static-1.8109",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58676",
  "crm-component-utils": "/crm-component-utils/static-1.39792",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6168",
  "customer-data-properties": "/customer-data-properties/static-1.52515",
  "external-options-client-types": "/external-options-client-types/static-1.4324",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7169",
  "property-value-citations": "/property-value-citations/static-1.3129",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8380",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10577",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5093",
  "content-icons-ui": "/content-icons-ui/static-1.2342",
  "idb-keyval": "/idb-keyval/static-1.48",
  "reactive-lib": "/reactive-lib/static-1.997",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.265",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.880",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7524",
  "crm-message-bus": "/crm-message-bus/static-1.43711",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23286",
  "events-data-lib": "/events-data-lib/static-1.521",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5006",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4206",
  "hs-resources": "/hs-resources/static-1.471",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1279",
  "onboarding-scopes": "/onboarding-scopes/static-1.6731",
  "onboarding-tours": "/onboarding-tours/static-1.17084",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14424",
  "academy-common-lib": "/academy-common-lib/static-1.14929",
  "dashboard-lib": "/dashboard-lib/static-1.82745",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19192",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18922",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8983",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11375",
  "user-context": "/user-context/static-1.5397",
  "reporting-plugins": "/reporting-plugins/static-1.10716",
  "reporting-reports": "/reporting-reports/static-1.68425",
  "hubs-service-types": "/hubs-service-types/static-1.1535",
  "purchase-motions-api": "/purchase-motions-api/static-1.6334",
  "signup-constants": "/signup-constants/static-1.19582",
  "nest": "/nest/static-1.513",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.640",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.182",
  "framework-listing-lib": "/framework-listing-lib/static-2.29449",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31379",
  "apps-service-types": "/apps-service-types/static-1.4018",
  "oauth-service-types": "/oauth-service-types/static-1.4514",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8340",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5299",
  "one-click-checkout": "/one-click-checkout/static-1.352",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7877",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15231",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3770",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10055",
  "redux-thunk": "/redux-thunk/static-2.77",
  "react-flip-move": "/react-flip-move/static-1.75",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29265",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13194",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4703",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.673",
  "ui-addon-opt": "/ui-addon-opt/static-4.8641",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6582",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5358",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3807",
  "data-token-picker": "/data-token-picker/static-1.16856",
  "FileManagerLib": "/FileManagerLib/static-1.40077",
  "content-media-compositions": "/content-media-compositions/static-2.17201",
  "media-bridge-lib": "/media-bridge-lib/static-1.19376",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22861",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3473",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7148",
  "card-properties-lib": "/card-properties-lib/static-1.44966",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37734",
  "crm-actions": "/crm-actions/static-1.6631",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44506",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9906",
  "customer-data-tracking": "/customer-data-tracking/static-1.7160",
  "calling-global-api": "/calling-global-api/static-1.65529",
  "calling-internal-common": "/calling-internal-common/static-1.31596",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66911",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59205",
  "commerce-products-lib": "/commerce-products-lib/static-1.10484",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3997",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4515",
  "crm-links": "/crm-links/static-1.6608",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4331",
  "formula-editor": "/formula-editor/static-1.14720",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4411",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.913",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3892",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49619",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4165",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.97",
  "smart-property-lib": "/smart-property-lib/static-1.8242",
  "tiered-pricing": "/tiered-pricing/static-1.1920",
  "topics-actions-lib": "/topics-actions-lib/static-1.442",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11261",
  "zustand": "/zustand/static-1.82",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.288",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7074",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1627",
  "growth-data-modal": "/growth-data-modal/static-1.5862",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3339",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2646",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1151",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7927",
  "academy-service-client": "/academy-service-client/static-1.3965",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39936",
  "SafeStorage": "/SafeStorage/static-1.4681",
  "video-embed": "/video-embed/static-1.36605",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24966",
  "viral-links-lib": "/viral-links-lib/static-1.7353",
  "nested-table": "/nested-table/static-1.511",
  "timezone-utils": "/timezone-utils/static-2.5523",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18310",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10129",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3484",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5606",
  "customer-data-views-management": "/customer-data-views-management/static-1.25982",
  "framework-data-table": "/framework-data-table/static-2.12507",
  "nudge-client-utils": "/nudge-client-utils/static-1.3121",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1459",
  "switchboard-lib": "/switchboard-lib/static-1.492",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1540",
  "app-users-service-client": "/app-users-service-client/static-1.5897",
  "app-users-service-types": "/app-users-service-types/static-1.5305",
  "mini-checkout-client": "/mini-checkout-client/static-1.27447",
  "onboarding-utils": "/onboarding-utils/static-1.5643",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2119",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29250",
  "checkout-sdk": "/checkout-sdk/static-3.24290",
  "payment-method-components": "/payment-method-components/static-1.7126",
  "touchless-buying-components": "/touchless-buying-components/static-1.6158",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3748",
  "edison-service-client-types": "/edison-service-client-types/static-1.670",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6862",
  "audio-components": "/audio-components/static-1.6311",
  "FileManagerImages": "/FileManagerImages/static-1.37588",
  "video-components": "/video-components/static-1.14115",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92780",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46697",
  "enrichment-lib": "/enrichment-lib/static-1.278",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4544",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1826",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20106",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19179",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11004",
  "crm-fe-perf": "/crm-fe-perf/static-1.23180",
  "calling-error-reporting": "/calling-error-reporting/static-1.31603",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11318",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6815",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1981",
  "commerce-permissions": "/commerce-permissions/static-1.1056",
  "products-iframe-lib": "/products-iframe-lib/static-1.8548",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10961",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6720",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10662",
  "sales-views-client-types": "/sales-views-client-types/static-1.4533",
  "bark-lib": "/bark-lib/static-1.16789",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.617",
  "policy-lib": "/policy-lib/static-1.7078",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10725",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2473",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2674",
  "user-context-client": "/user-context-client/static-1.4787",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4810",
  "outpost": "/outpost/static-1.4435",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22126",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4122",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "crm-export-dialog": "/crm-export-dialog/static-1.6561",
  "crm-view-components": "/crm-view-components/static-1.1061",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.67",
  "customer-data-associations": "/customer-data-associations/static-1.7605",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.81",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2878",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3197",
  "whisper-core-api": "/whisper-core-api/static-1.7283",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15516",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46800",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.838",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4266",
  "company-details-components": "/company-details-components/static-1.6481",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.833",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15681",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3731",
  "social-insights-client-types": "/social-insights-client-types/static-1.22692",
  "crm_universal": "/crm_universal/static-1.22468",
  "customer-data-email": "/customer-data-email/static-1.18495",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37935",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13260",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55677",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22151",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18767",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72789",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5607",
  "data-agent-utils": "/data-agent-utils/static-1.340",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10158",
  "utility-belt": "/utility-belt/static-1.2811",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23753",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7968",
  "customer-data-rte": "/customer-data-rte/static-1.33609",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6238",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5383",
  "qrcode-generator": "/qrcode-generator/static-1.73",
  "quotes-client-types": "/quotes-client-types/static-1.38879",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36758",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16323",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7886",
  "hub-http-contrib": "/hub-http-contrib/static-1.3317",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5490",
  "access-control-lib": "/access-control-lib/static-1.10713",
  "EmailComponents": "/EmailComponents/static-1.55506",
  "EmailData": "/EmailData/static-1.54184",
  "redux-less": "/redux-less/static-2.9755",
  "company-details-service-types": "/company-details-service-types/static-1.4217",
  "segments-query-core": "/segments-query-core/static-1.1701",
  "pricing-pages-api": "/pricing-pages-api/static-1.15546",
  "sequences-lib": "/sequences-lib/static-1.8504",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.41002",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7506",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55693",
  "commerce-products-api": "/commerce-products-api/static-1.2667",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57751",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103467",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81510",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28868",
  "ContentComponents": "/ContentComponents/static-2.72037",
  "ContentData": "/ContentData/static-1.69156",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10972",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2080",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47088",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1950",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19645",
  "automation-ui-types": "/automation-ui-types/static-1.20563",
  "messaging-types-lib": "/messaging-types-lib/static-1.46825",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4787",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8361",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.816",
  "price-books-api": "/price-books-api/static-1.1693",
  "price-books-components": "/price-books-components/static-1.1751",
  "property-description-translator": "/property-description-translator/static-1.4119",
  "ramp-editor": "/ramp-editor/static-1.854",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3795",
  "totals-ui-components": "/totals-ui-components/static-1.24254",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9601",
  "advanced-menus-core": "/advanced-menus-core/static-1.15547",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12424",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6479",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7615",
  "data-token-views": "/data-token-views/static-1.16837",
  "forms-utils-lib": "/forms-utils-lib/static-1.13065",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13553",
  "react-tinymce": "/react-tinymce/static-1.55934",
  "simple-menus-core": "/simple-menus-core/static-1.15546",
  "simple-menus-lib": "/simple-menus-lib/static-1.17063",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55060",
  "tinymce-data": "/tinymce-data/static-1.41145",
  "tinymce-plugins": "/tinymce-plugins/static-1.58174",
  "tinymce-themes": "/tinymce-themes/static-1.57030",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16393",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34799",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7229",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7788",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.182",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3651",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2662",
  "ContentEditorUI": "/ContentEditorUI/static-2.77860",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4190",
  "web-interactives-components": "/web-interactives-components/static-1.14218",
  "web-interactives-data": "/web-interactives-data/static-1.14219",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1399",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1569",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1257",
  "line-items-api": "/line-items-api/static-1.1068",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4016",
  "FireAlarmUi": "/FireAlarmUi/static-1.4704",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4368",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22499",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21962",
  "data-studio-ubb": "/data-studio-ubb/static-1.3468",
  "interframe": "/interframe/static-3.5032",
  "layout-dnd-components": "/layout-dnd-components/static-1.12934",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11909",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9247",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27610",
  "content-management-data-lib": "/content-management-data-lib/static-1.5922",
  "copilot-plugins": "/copilot-plugins/static-1.11785",
  "cta-picker": "/cta-picker/static-1.37045",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3866",
  "editor-components": "/editor-components/static-1.13620",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8769",
  "error-messaging-js": "/error-messaging-js/static-1.5474",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86518",
  "layout-data-lib": "/layout-data-lib/static-1.10234",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.70",
  "redux-request-state": "/redux-request-state/static-1.10926",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2024",
  "smart-content-core": "/smart-content-core/static-1.43135",
  "smart-content-lib": "/smart-content-lib/static-1.43788",
  "social-composer-lib": "/social-composer-lib/static-1.60210",
  "structured-content-lib": "/structured-content-lib/static-1.25876",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53904",
  "tinymce-copilot": "/tinymce-copilot/static-1.17128",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8237",
  "automation-ui-routing": "/automation-ui-routing/static-1.21920",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5877",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42754",
  "reporting-enablement": "/reporting-enablement/static-1.23786",
  "forms-ai-lib": "/forms-ai-lib/static-1.4734",
  "codemirror-dlb": "/codemirror-dlb/static-1.59419",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6716",
  "report-customization-components": "/report-customization-components/static-1.13870",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13754",
  "reporting-filters": "/reporting-filters/static-1.965",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2525",
  "segments-client-types": "/segments-client-types/static-1.11463"
}
};
